exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".playfair-block {\r\n  text-align: center;\r\n  display: inline-block;\r\n  padding-left: 4px;\r\n  padding-right: 4px;\r\n  font-family: \"Courier New\", Courier, \"Lucida Sans Typewriter\", \"Lucida Typewriter\", monospace;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Jeffrey/Documents/web development/ciphersite/src/app/playfair/playfair.component.css
// module id = ../../../../../src/app/playfair/playfair.component.css
// module chunks = main